import { connect } from "react-redux";
import Subsection from "../../../../components/features/navbar/Subsection";

import { getSelectedClient } from "core/selectors";

export default connect(state => ({
    selectedClient: getSelectedClient(state),
}), { })(Subsection);